import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { Skeleton, Divider, Typography } from "antd";
import { Eye, EyeSlash } from "react-bootstrap-icons"; // ใช้ไอคอนจาก react-bootstrap-icons
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import {
  //setting
  countryAddress2,
  provinceAddress,
  districtAddress,
  subdistrictAddress,
} from "../../redux/actions";

const inputStyle = {
  width: "100%",
  height: "41px",
  borderRadius: "8px",
};

const validStyle = {
  minHeight: "20px",
  marginTop: "5px",
  marginLeft: "10px",
};
const BasicInformationForm = ({
  basicInfoData,
  setBasicInfoData,
  lang,

  selectCountryOption,
  selectProvinceOption,
  selectDistrictOption,
  selectSubDistrictOption,
  //checkfield
  basicInfoErrors,
  handleBlur,
  touchedFields,
}) => {
  const dispatch = useDispatch();
  console.log("Child :: basicInfoData", basicInfoData);

  const [showPassport, setShowPassport] = useState(false);
  //selected ID

  const [selectProvince, setSelectProvince] = useState("");
  const [selectDistrict, setSelectDistrict] = useState("");
  const [selectSubDistrict, setSelectSubDistrict] = useState("");
  const [selectPostal_code, setSelectPostal_code] = useState("");

  console.log(
    "selectProvince:",
    selectProvince,
    "selectDistrict:",
    selectDistrict,
    "selectSubDistrict:",
    selectSubDistrict,
    "selectPostal_code:",
    selectPostal_code
  );

  useEffect(() => {
    if (basicInfoData?.length > 0) {
      const basicInfo = basicInfoData[0]; // Directly use the first item

      setSelectProvince(Number(basicInfo.province));
      setSelectDistrict(Number(basicInfo.district));
      setSelectSubDistrict(Number(basicInfo.subDistrict));
      setSelectPostal_code(Number(basicInfo.postalCode));
    } else {
      console.log("No company info available");
    }
  }, [basicInfoData]);

  useEffect(() => {
    // ดึงข้อมูล Province จาก API
    dispatch(provinceAddress({ lang: "both" }));
    dispatch(countryAddress2("both"));
  }, []);

  useEffect(() => {
    if (selectProvince) {
      // ดึงข้อมูล District เมื่อเลือก Province
      dispatch(districtAddress({ lang: "both", id: selectProvince }));
    }
  }, [selectProvince, lang]); // โหลดใหม่เมื่อ selectProvince หรือ lang เปลี่ยน

  useEffect(() => {
    if (selectDistrict) {
      // ดึงข้อมูล Sub District เมื่อเลือก District
      dispatch(subdistrictAddress({ id: selectDistrict, lang: "both" }));
    }
  }, [selectDistrict, lang]); // โหลดใหม่เมื่อ selectDistrict หรือ lang เปลี่ยน

  useEffect(() => {
    if (selectSubDistrict && selectSubDistrictOption.length > 0) {
      const found = selectSubDistrictOption.find(
        (item) => item.value === Number(selectSubDistrict)
      );
      console.log("found:", found);
      if (found) {
        setSelectPostal_code(found.post_code || "N/A"); // ถ้าไม่มีค่า ให้ใช้ "N/A"
        handleInputChange("postalCode", 0, found.post_code);
      }
    }
  }, [selectSubDistrict]);

  //Handle input change
  const handleInputChange = (fieldName, index, value) => {
    setBasicInfoData((prevData) => {
      // Create a shallow copy of the array
      const updatedData = [...prevData];
      // Update the specific field for the targeted index
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: value,
      };
      return updatedData;
    });
  };

  return (
    <>
      <Container className="">
        {Array.isArray(basicInfoData) &&
          basicInfoData.length > 0 &&
          basicInfoData.map((data, index) => (
            <Form
              // noValidate
              // validated={false}
              key={index}
              className="p-4"
              style={{
                color: "rgb(0, 0, 0)",
              }}
            >
              <Divider orientation="left">Basic Information</Divider>

              {/* Row 1 */}
              <Row className="mb-0">
                <Col md={4}>
                  <Form.Group controlId="formFirstName">
                    <Form.Label>First Name*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      style={inputStyle}
                      value={data.firstName || ""}
                      onBlur={() => handleBlur("firstName")}
                      onChange={(e) =>
                        handleInputChange("firstName", index, e.target.value)
                      }
                      isInvalid={
                        touchedFields?.firstName && !!basicInfoErrors?.firstName
                      }
                      
                      isValid={!basicInfoErrors?.firstName && !!data.firstName}
                    />

                    <div style={validStyle}>
                      {basicInfoErrors?.firstName && touchedFields?.firstName && (
                        <span className="text-danger">
                          {basicInfoErrors?.firstName}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formLastName">
                    <Form.Label>Last Name*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      style={inputStyle}
                      value={data.lastName || ""}
                      onChange={(e) =>
                        handleInputChange("lastName", index, e.target.value)
                      }
                      onBlur={() => handleBlur("lastName")}
                      isInvalid={
                        touchedFields?.lastName && !!basicInfoErrors?.lastName
                      }
                      isValid={
                        touchedFields?.lastName &&
                        !basicInfoErrors?.lastName &&
                        !!data.lastName
                      }
                      
                    />

                    <div style={validStyle}>
                      {basicInfoErrors?.lastName && touchedFields?.lastName && (
                        <span className="text-danger">
                          {basicInfoErrors?.lastName}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group controlId="formNickName">
                    <Form.Label>Nick Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nick Name"
                      style={inputStyle}
                      value={data.nickName || ""}
                      onChange={(e) =>
                        handleInputChange("nickName", index, e.target.value)
                      }
                      onBlur={() => handleBlur("nickName")}
                      isInvalid={
                        touchedFields?.nickName && !!basicInfoErrors?.nickName
                      }
                      isValid={
                        touchedFields?.nickName &&
                        !basicInfoErrors?.nickName &&
                        !!data.nickName
                      }
                    />
                    <div style={validStyle}>
                      {basicInfoErrors?.nickName && touchedFields?.nickName && (
                        <span className="text-danger">
                          {basicInfoErrors?.nickName}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 2 */}
              <Row className="mb-0">
                <Col md={4}>
                  <Form.Group controlId="formGender">
                    <Form.Label>Gender*</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        type="radio"
                        label="Male"
                        name="gender"
                        value="male"
                        onChange={(e) =>
                          handleInputChange("gender", index, e.target.value)
                        }
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="Female"
                        name="gender"
                        value="female"
                        onChange={(e) =>
                          handleInputChange("gender", index, e.target.value)
                        }
                      />
                    </div>
                    <div style={validStyle}>
                      {basicInfoErrors?.gender && touchedFields?.gender && (
                        <span className="text-danger">
                          {basicInfoErrors?.gender}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formDob">
                    <Form.Label>Date of Birth*</Form.Label>
                    <Form.Control
                      type="date"
                      placeholder="DD/MM/YYYY"
                      style={inputStyle}
                      value={data.birth || ""}
                      onChange={(e) =>
                        handleInputChange("birth", index, e.target.value)
                      }
                      onBlur={() => handleBlur("birth")}
                      isInvalid={touchedFields?.birth && !!basicInfoErrors?.birth}
                      isValid={
                        touchedFields?.birth &&
                        !basicInfoErrors?.birth &&
                        !!data.birth
                      }
                    />
                    <div style={validStyle}>
                      {basicInfoErrors?.birth && touchedFields?.birth && (
                        <span className="text-danger">
                          {basicInfoErrors?.birth}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formNationality">
                    <Form.Label>Nationality*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nationality"
                      style={inputStyle}
                      value={data.national}
                      onChange={(e) =>
                        handleInputChange("national", index, e.target.value)
                      }
                      onBlur={() => handleBlur("national")}
                      isInvalid={
                        touchedFields?.national && !!basicInfoErrors?.national
                      }
                      isValid={
                        touchedFields?.national &&
                        !basicInfoErrors?.national &&
                        !!data.national
                      }
                    />
                    <div style={validStyle}>
                      {basicInfoErrors?.national && touchedFields?.national && (
                        <span className="text-danger">
                          {basicInfoErrors?.national}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 3 */}
              <Row className="mb-0">
                <Col md={4}>
                  <Form.Group controlId="formEmail">
                    <Form.Label>Email*</Form.Label>
                    <Form.Control
                      type="text"
                      name="email_fake_12345" // ตั้งชื่อ name ที่ Browser ไม่รู้จัก
                      placeholder="Email"
                      style={inputStyle}
                      value={data.email || ""}
                      autoComplete="new-password"
                      onChange={(e) =>
                        handleInputChange("email", index, e.target.value)
                      }
                      onBlur={() => handleBlur("email")}
                      isInvalid={touchedFields?.email && !!basicInfoErrors?.email}
                      isValid={
                        touchedFields?.email &&
                        !basicInfoErrors?.email &&
                        !!data.email
                      }
                    />
                    <div style={validStyle}>
                      {basicInfoErrors?.email && touchedFields?.email && (
                        <span className="text-danger">
                          {basicInfoErrors?.email}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group controlId="formPhone">
                    <Form.Label>Phone Number *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Phone Number "
                      style={inputStyle}
                      value={data.phoneNumber || ""}
                      onChange={(e) =>
                        handleInputChange("phoneNumber", index, e.target.value)
                      }
                      onBlur={() => handleBlur("phoneNumber")}
                      isInvalid={
                        touchedFields?.phoneNumber &&
                        !!basicInfoErrors?.phoneNumber
                      }
                      isValid={
                        touchedFields?.phoneNumber &&
                        !basicInfoErrors?.phoneNumber &&
                        !!data.phoneNumber
                      }
                    />
                    <div style={validStyle}>
                      {basicInfoErrors?.phoneNumber &&
                        touchedFields?.phoneNumber && (
                          <span className="text-danger">
                            {basicInfoErrors?.phoneNumber}
                          </span>
                        )}
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group controlId="formIdPassport">
                    <Form.Label>ID/PASSPORT NO.*</Form.Label>

                    <InputGroup>
                      <Form.Control
                        type={showPassport ? "text" : "password"} // เปลี่ยนจาก password → text
                        name="Id_fake_12345" // ตั้งชื่อ name ที่ Browser ไม่รู้จัก
                        placeholder="ID/PASSPORT NO."
                        style={inputStyle}
                        autoComplete="new-password"
                        value={data.passport || ""}
                        onChange={(e) =>
                          handleInputChange("passport", index, e.target.value)
                        }
                        onBlur={() => handleBlur("passport")}
                        isInvalid={
                          touchedFields?.passport && !!basicInfoErrors?.passport
                        }
                        isValid={
                          touchedFields?.passport &&
                          !basicInfoErrors?.passport &&
                          !!data.passport
                        }
                      />
                      {/* <Button
                      variant="outline-secondary"
                      onClick={() => setShowPassport(!showPassport)}
                    >{showPassport ? <EyeSlash /> : <Eye />} </Button> */}
                    </InputGroup>

                    <div style={validStyle}>
                      {basicInfoErrors?.passport && touchedFields?.passport && (
                        <span className="text-danger">
                          {basicInfoErrors?.passport}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Divider orientation="left">Address Information</Divider>

              {/* Row 4 */}
              <Row className="mb-0">
                <Col md={6}>
                  <Form.Group controlId="formAddress1">
                    <Form.Label>Address*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Address"
                      style={inputStyle}
                      value={data.address || ""}
                      onChange={(e) =>
                        handleInputChange("address", index, e.target.value)
                      }
                      onBlur={() => handleBlur("address")}
                      isInvalid={
                        touchedFields?.address && !!basicInfoErrors?.address
                      }
                      isValid={
                        touchedFields?.address &&
                        !basicInfoErrors?.address &&
                        !!data.address
                      }
                    />
                    <div style={validStyle}>
                      {basicInfoErrors?.address && touchedFields?.address && (
                        <span className="text-danger">
                          {basicInfoErrors?.address}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formAddress2">
                    <Form.Label>Address 2</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Address 2"
                      style={inputStyle}
                      value={data.address2 || ""}
                      onChange={(e) =>
                        handleInputChange("address2", index, e.target.value)
                      }
                      onBlur={() => handleBlur("address2")}
                      isInvalid={
                        touchedFields?.address2 && !!basicInfoErrors?.address2
                      }
                      isValid={
                        touchedFields?.address2 &&
                        !basicInfoErrors?.address2 &&
                        !!data.address2
                      }
                    />
                    <div style={validStyle}>
                      {basicInfoErrors?.address2 && touchedFields?.address2 && (
                        <span className="text-danger">
                          {basicInfoErrors?.address2}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 5 */}
              <Row className="mb-0">
                <Col md={4}>
                  <Form.Group controlId="formCountry">
                    <Form.Label>Country*</Form.Label>
                    <Form.Select
                      placeholder="Select Country"
                      style={inputStyle}
                      onChange={(e) => {
                        handleInputChange("country", index, e.target.value);
                      }}
                      value={data.country || ""}
                      onBlur={() => handleBlur("country")}
                      isInvalid={
                        touchedFields?.country && !!basicInfoErrors?.country
                      }
                      isValid={
                        touchedFields?.country &&
                        !basicInfoErrors?.country &&
                        !!data.country
                      }
                    >
                      <option style={{ zIndex: "1050" }}>
                        Please select country {/* แสดง label ตามภาษา */}
                      </option>
                      {selectCountryOption &&
                        selectCountryOption.map((item, index) => (
                          <option
                            key={index}
                            value={item.value || ""}
                            style={{ zIndex: "1050" }}
                          >
                            {lang === "en" ? item.label1 : item.label2}{" "}
                            {/* แสดง label ตามภาษา */}
                          </option>
                        ))}
                    </Form.Select>
                    <div style={validStyle}>
                      {basicInfoErrors?.country && touchedFields?.country && (
                        <span className="text-danger">
                          {basicInfoErrors?.country}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formProvince">
                    <Form.Label>Province*</Form.Label>
                    <Form.Select
                      placeholder="Select Province"
                      style={inputStyle}
                      onChange={(e) => {
                        handleInputChange("province", index, e.target.value);
                        setSelectProvince(e.target.value);
                      }}
                      value={data.province || ""}
                      onBlur={() => handleBlur("province")}
                      isInvalid={
                        touchedFields?.province && !!basicInfoErrors?.province
                      }
                      isValid={
                        touchedFields?.province &&
                        !basicInfoErrors?.province &&
                        !!data.province
                      }
                    >
                      <option style={{ zIndex: "1050" }}>
                        Please select province {/* แสดง label ตามภาษา */}
                      </option>
                      {selectProvinceOption &&
                        selectProvinceOption.map((item, index) => (
                          <option
                            key={index}
                            value={item.value || ""}
                            style={{ zIndex: "1050" }}
                          >
                            {lang === "en" ? item.label1 : item.label2}{" "}
                            {/* แสดง label ตามภาษา */}
                          </option>
                        ))}
                    </Form.Select>
                    <div style={validStyle}>
                      {basicInfoErrors?.province && touchedFields?.province && (
                        <span className="text-danger">
                          {basicInfoErrors?.province}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formDistrict">
                    <Form.Label>District*</Form.Label>
                    <Form.Select
                      style={inputStyle}
                      disabled={!selectProvince} // ป้องกันการเลือก District ก่อนเลือก Province
                      onChange={(e) => {
                        handleInputChange("district", index, e.target.value);
                        setSelectDistrict(e.target.value);
                      }}
                      value={data.district || ""}
                      onBlur={() => handleBlur("district")}
                      isInvalid={
                        touchedFields?.district && !!basicInfoErrors?.district
                      }
                      isValid={
                        touchedFields?.district &&
                        !basicInfoErrors?.district &&
                        !!data.district
                      }
                    >
                      <option value="" disabled selected>
                        Please select district
                      </option>
                      {selectDistrictOption &&
                        selectDistrictOption.map((item, index) => (
                          <option key={index} value={item.value || ""}>
                            {lang === "en" ? item.label1 : item.label2}{" "}
                            {/* แสดง label ตามภาษา */}
                          </option>
                        ))}
                    </Form.Select>
                    <div style={validStyle}>
                      {basicInfoErrors?.district && touchedFields?.district && (
                        <span className="text-danger">
                          {basicInfoErrors?.district}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 6 */}
              <Row className="mb-0">
                <Col md={4}>
                  <Form.Group controlId="formSubDistrict">
                    <Form.Label>Sub District*</Form.Label>
                    <Form.Select
                      disabled={!selectDistrict && !selectProvince} // ป้องกันการเลือก Sub District ก่อนเลือก District
                      style={inputStyle}
                      onChange={(e) => {
                        handleInputChange("subDistrict", index, e.target.value);
                        setSelectSubDistrict(e.target.value);
                      }}
                      value={data.subDistrict || ""}
                      onBlur={() => handleBlur("subDistrict")}
                      isInvalid={
                        touchedFields?.subDistrict &&
                        !!basicInfoErrors?.subDistrict
                      }
                      isValid={
                        touchedFields?.subDistrict &&
                        !basicInfoErrors?.subDistrict &&
                        !!data.subDistrict
                      }
                    >
                      <option value="" disabled selected>
                        Please select subdistrict
                      </option>
                      {selectSubDistrictOption &&
                        selectSubDistrictOption.map((item, index) => (
                          <option key={index} value={item.value || ""}>
                            {lang === "en" ? item.label1 : item.label2}{" "}
                            {/* แสดง label ตามภาษา */}
                          </option>
                        ))}
                    </Form.Select>
                    <div style={validStyle}>
                      {basicInfoErrors?.subDistrict &&
                        touchedFields?.subDistrict && (
                          <span className="text-danger">
                            {basicInfoErrors?.subDistrict}
                          </span>
                        )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formPostalCode">
                    <Form.Label>Postal Code*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Please select sub district"
                      style={inputStyle}
                      value={selectPostal_code || ""} // แสดงค่าอัตโนมัติ
                      disabled // ป้องกันการกรอกข้อมูลด้วยมือ
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          ))}
      </Container>
    </>
  );
};

// export default BasicInformationForm;

const mapStateToProps = (state) => {
  console.log("Redux State:", state); // ตรวจสอบ state ทั้งหมด

  return {
    //Address
    selectCountryOption: state.settings.selectCountry2,
    selectProvinceOption: state.settings.selectProvince,
    selectDistrictOption: state.settings.selectDistrict,
    selectSubDistrictOption: state.settings.selectSubDistrict,
  };
};

const mapDispatchToProps = {
  //Address
  countryAddress2,
  provinceAddress,
  districtAddress,
  subdistrictAddress,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BasicInformationForm);
